import { useEffect } from "react";
import { useParams } from "react-router-dom";

import PageTab from "components/common/pageTab";
import TopImage from "components/common/topImage";

import { fnSetTimeTab } from 'assets/js/commonUtil';
import { pageMenuTabList01 } from 'types/common';

import 'assets/css/company.scss';

export default function History() {
  const {id} = useParams<{id: string}>();
  pageMenuTabList01[1].on = true;

  useEffect(() => {  
    fnSetTimeTab();
  }, []);

  return (
    <div className="page_content">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/company-hero_1920x1080.jpg.jpg" imgText="연혁" textcolor="#333"></TopImage>
      <PageTab props={pageMenuTabList01}></PageTab>
      <div className="hisoty container">
        
        <div className="container-title">
          천호엔케어의 <span className="highlight">도전과 혁신</span>은<br/>
          지금 이 순간에도 계속됩니다.
        </div>

        <div className="page-inner-tab">
          <div className="tabs col4">
            <div className="tab on">2020년대</div>
            <div className="tab">2010년대</div>
            <div className="tab">2000년대</div>
            <div className="tab">1980~1900년대</div>
          </div>
        </div>
        
        <div className="history-content page-inner-tab">
          
          <div className="history-list tab-list on">
            <div className="history-list-item">
              <div className="history-img">
                <div className="history-period">2020년대</div>
                <div className="history-img-sub">
                  <div style={{padding: '10px 0'}}>
                    <img src="https://img.chunhomall.com/images/brand_site/company-section-2020-01_600x400.jpg.jpg" alt="" />
                  </div>
                  <div style={{padding: '10px 0'}}>
                    <img src="https://img.chunhomall.com/images/brand_site/company-section-2020-02_600x400.jpg.jpg" alt="" />
                  </div>
                  <div style={{padding: '10px 0'}}>
                    <img src="https://img.chunhomall.com/images/brand_site/company-section-2020-03_600x400.jpg.jpg" alt="" />
                  </div>
                </div>
                
                
              </div>
              <div className="history-item">
                <div className="item-title">세계를 무대로 뻗어나가다</div>
                <div className="item-info">
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2025.12</div>
                        <div className="line-title-sub">
                          <div>KPDA 대한민국 패키지 디자인대전</div>
                          <div>‘사향천진단’ 동상, 팩스타상 2품목 수상</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2025.09</div>
                        <div className="line-title-sub">
                          <div>2025소비자만족 브랜드대상 1위</div>
                          <div>건강즙, 스틱젤리, 아이키쑤욱 수상</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2025.01</div>
                        <div className="line-title-sub">어린이 건강식품 브랜드 ‘1005키디’ 런칭</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2024.12</div>
                        <div className="line-title-sub">
                          <div>KPDA 대한민국 패키지 디자인대전</div>
                          <div>‘퓨어’ 은상, ‘황제흑염소’ 동상, 팩스타상 2품목 수상</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2024.08</div>
                        <div className="line-title-sub">
                          <div>2024대한민국 고객만족 브랜드대상</div>
                          <div>건강식품 브랜드 건강즙, 스틱젤리 부문 4년 연속 수상</div>
                          <div>건강기능식품 브랜드 ‘아이키쑤욱’ 키성장 부문 2년 연속 수상</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2023.12</div>
                        <div className="line-title-sub">KPDA대한민국 패키지디자인대전 10년 연속 팩스타상 수상</div>
                      </div>
                    </div>
                  </div>
                  
                
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2023.07</div>
                        <div className="line-title-sub">중국 틱톡 플래그십 스토어 개설</div>
                      </div>
                    </div>
                  </div>

                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2022.12</div>
                        <div className="line-title-sub fontbold">여성가족부 인증 '가족친화 최고기업' 선정</div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2022.03</div>
                        <div className="line-title-sub">수출 300만불 달성</div>
                      </div>
                    </div>
                  </div>

                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2020.12</div>
                        <div className="line-title-sub">베트남 유통기업 '수 코리아' 파트너십 체결</div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2020.08</div>
                        <div className="line-title-sub">중국 티몰 플래그쉽 스토어 개설</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="history-list tab-list">
            <div className="history-list-item">
              <div className="history-img">
                <div className="history-period">2010년대</div>
                <div className="history-img-sub">
                  <div style={{padding: '10px 0'}}>
                    <img src="https://img.chunhomall.com/images/brand_site/company-section-2010-01_600x400.jpg.jpg" alt="" />
                  </div>
                  <div style={{padding: '10px 0'}}>
                    <img src="https://img.chunhomall.com/images/brand_site/company-section-2010-02_600x400.jpg.jpg" alt="" />
                  </div>
                  <div style={{padding: '10px 0'}}>
                    <img src="https://img.chunhomall.com/images/brand_site/company-section-2010-03_600x400.jpg.jpg" alt="" />
                  </div>
                </div>
              </div>
              <div className="history-item">
                <div className="item-title">브랜드 확장, 헬스케어 드렌드를 선도한다</div>
                <div className="item-info">
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2019.11</div>
                        <div className="line-title-sub">토탈케어 건강기능식품 '액티브솔루션' 런칭</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2019.02</div>
                        <div className="line-title-sub">어린이 키성장 건강기능식품 '아이키쑤욱' 런칭</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2018.12</div>
                        <div className="line-title-sub">&lt;2018 대한민국 퍼스트 브랜드 대상&gt; 건강즙 부문 수상</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2018.07</div>
                        <div className="line-title-sub">&lt;2018 올해의 브랜드 대상&gt; 자연건강식품 부문 수상</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2018.03</div>
                        <div className="line-title-sub fontbold">'천호엔케어'로 사명 변경</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2017.05</div>
                        <div className="line-title-sub">'천심본' &lt;2017 건강기능식품 대상&gt; 홍삼 우수품질관리 부문 수상</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2017.04</div>
                        <div className="line-title-sub">&lt;2017 국가브랜드 대상&gt; 건강기능식품 부문 수상</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2017.01</div>
                        <div className="line-title-sub">미국 FDA 획득</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2016.11</div>
                        <div className="line-title-sub">
                          <div>'녹용홍삼' &lt;2016 소비자의 선택&gt; 건강식품 부문 수상</div>
                          <div>'우먼솔루션' &lt;2016 건강기능식품 대상&gt; 여성 갱년기 개선 부문 수상</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2013.13</div>
                        <div className="line-title-sub">중소기업진흥공단 으뜸기업 선정</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2012.12</div>
                        <div className="line-title-sub">백만불 수출의 탑 수상</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2012.10</div>
                        <div className="line-title-sub">2012년 대한민국 일하기 좋은 100대 기업 선정</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2011.12</div>
                        <div className="line-title-sub">'마시는 산수유 진액' &lt;올해를 빛낸 대한민국 히트상품&gt; 선정</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2011.11</div>
                        <div className="line-title-sub">
                          <div>'천호통마늘진액' &lt;2011 농식품 파워브랜드전&gt; 은상 수상</div>
                          <div>여성가족부 인증 '가족친화기업' 선정</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2011.07</div>
                        <div className="line-title-sub">부산시 고용우수기업 인증</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2010.12</div>
                        <div className="line-title-sub">위해요소 중정관리기준(HACCP) 적용 업소 지정</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2010.11</div>
                        <div className="line-title-sub">우수건강기능식품 제조 기준(GMP) 적용 업소 지정</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2010.07</div>
                        <div className="line-title-sub">경남 양산 생산공장 준공</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2010.03</div>
                        <div className="line-title-sub">'수면장애 개선 및 쾌면을 위한 건강식품' 특허 획득</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="history-list tab-list">
            <div className="history-list-item">
              <div className="history-img">
                <div className="history-period">2000년대</div>
                <div className="history-img-sub">
                  <div style={{padding: '10px 0'}}>
                    <img src="https://img.chunhomall.com/images/brand_site/company-section-2000_600x400.jpg.jpg" alt="" />
                  </div>
                </div>
              </div>
              <div className="history-item">
                <div className="item-title">헬스케어 기업으로 도약, 전문성을 키우다</div>
                <div className="item-info">
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2009.07</div>
                        <div className="line-title-sub">
                          <div>'기술혁신형 기업(이노비즈) 선정'</div>
                          <div>'천호통마늘진액' 	&lt;2009 한국에서 가장 신뢰받는 브랜드상	&gt; 수상</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2008.06</div>
                        <div className="line-title-sub">'양파를 이용한 건강식품' 발명 특허</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2007.10</div>
                        <div className="line-title-sub">'마늘을 이용한 건강식품' 발명 특허</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2004.06</div>
                        <div className="line-title-sub">산수유 원료 건강식품 발명 특허 획득</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2003.10</div>
                        <div className="line-title-sub">산업자원부 - 품질경쟁력 우수기업 선정</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2002.03</div>
                        <div className="line-title-sub">ISO 9001, HACCP 시스템 인증</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2002.02</div>
                        <div className="line-title-sub">부산광역시 - 품질경쟁력 우수기업 선정</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2001.04</div>
                        <div className="line-title-sub">대통령 표창 - 사회복지증진 기여 공로</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">2000.02</div>
                        <div className="line-title-sub">보건복지부 장관 표창 - 사회복지증진</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="history-list tab-list">
            <div className="history-list-item">
              <div className="history-img">
                <div className="history-period">1980 ~ 1990년대</div>
                <div className="history-img-sub">
                  <div style={{padding: '10px 0'}}>
                    <img src="https://img.chunhomall.com/images/brand_site/company-section-1980_600x400.jpg.jpg" alt="" />
                  </div>
                </div>
              </div>
              <div className="history-item">
              
                <div className="item-title">건강식품의 혁신을 일으키다</div>
                <div className="item-info">
                  
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">1999.04</div>
                        <div className="line-title-sub">태릉선수촌 '강화사자발쑥', '사슴한마리' 공급</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">1996.02</div>
                        <div className="line-title-sub">국내 최초 콘드로이친 개발</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">1994.06</div>
                        <div className="line-title-sub">'달팽이 원료 건강식품' 발명 특허</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">1991.03</div>
                        <div className="line-title-sub">'천호엑기스(달팽이)' 출시</div>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="line"><div className="v-line"></div><div className="line-circle"/></div>
                    <div className="item-content">
                      <div className="line-title">
                        <div className="time">1984.08</div>
                        <div className="line-title-sub fontbold">천호식품 설립</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
